import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  monthlyButton: true,
  grandButton: true,
  weeklyButton: true,
  allWinners: [],
  phaseBonusModalToBeDisplayed: {},
  bonusDailyModal: null,
  achievementNotificationData: [],
  achievements: [],
  bonusPhasesNum: 0,
  phaseBonusList: [],
  checkedNotificationId: '',
  checkedNotificationReadStatus: false,
  notificationPrizeWon: false,
  notificationRewardId: '',
  notificationRewardName: '',
  hashedPass: null,
  twoStepVerificationBlockedUser: null,
  twoStepVerificationWrongPin: null,
  twoStepVerificationServerError: null,
  twoStepVerificationVerified: null,
  forgotPasswordInfo: '',
  notificationsNames: {
    grandPrize: 'Grand Prize',
    dailyPrize: 'Daily Prize',
    weeklyPrize: 'Weekly Prize',
    monthlyPrize: 'Monthly Prize',
    topRanking: 'Top Ranking',
    levelUp: 'Level Up',
  },
  prizes: {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    GRAND: 'GRAND',
  },
  showmodalForRanking: {
    userLevel: '',
    bonusPoints: '',
    gamesEarned: '',
  },
  showmodalForLevelUp: {
    userLevel: '',
    bonusPoints: '',
    gamesEarned: '',
  },
  moreWinnersButton: false,
  moreWinnersMButton: false,
  moreWinnersIButton: false,
  numberOfTotalPrizes: 5,
  numberOfDefaultDisplayWinners: 5,
  extraArraysWinners: [],
  fetchingInitialWinners: false,
  visitorWinners: [],
  grandWin: [],
  monthlyWin: [],
  instantWin: [],
  monthlyPrize: {},
  grandPrize: {},
  dailyPrize: {},
  weeklyPrize: {},
  carouselPrizes: [],
  requestPinResponse: null,
  chargePinResponse: null,
  storedBundles: [],
  registrationInfoMsisdn: '',
  monthlyPrizeForLeaderboard: [],
  grandPrizeForLeaderboard: [],
  dailyPrizeForLeaderboard: [],
  weeklyPrizeForLeaderboard: [],
  monthlyWinnersForLeaderboard: [],
  dailyWinnersForLeaderboard: [],
  weeklyWinnersForLeaderboard: [],
  grandWinnersForLeaderboard: [],
  monthlyRankForLeaderboard: [],
  grandRankForLeaderboard: [],
  dailyRankForLeaderboard: [],
  weeklyRankForLeaderboard: [],
  availablePrizeTypes: [],
  showmodalForDefaultPrizeDetails: false,
  jwtInVuex: '',
  firstTimeEntry: false,
  userAuthorized: false,
  profilePath: false,
  bundleId: 0,
  bundleData: {
    numberOfGames: '',
    price: '',
    currencyCode: '',
    points: '',
  },
  notifications: [],
  gameHistoryData: [],
  opponentDetails: {},
  gameDescriptionDetails: {},
  showHistory: false,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/index.js